// extracted by mini-css-extract-plugin
export default {"date":"QCEbqJh3yhw4VOto0UUR","container":"BRugoI0uww3QrpoRZjAb","messages":"bN2WnHAyEIlCQvJAc2Ik"};